import { useSelector } from 'react-redux';
import { getOAuthsEnabled } from '../flow-initial/getFlowConfig';
import { OAuthProviders } from './OAuthProviders';
import { getIsAppleUngated } from '../apple/appleUtils';
import { useEffect } from 'react';
export const useOAuthSignup = () => {
  const oAuthsEnabledByFlowConfig = getOAuthsEnabled();
  const atLeastOneOAuthEnabled = Object.values(oAuthsEnabledByFlowConfig).some(value => value);
  const isAppleUngated = useSelector(getIsAppleUngated);
  useEffect(() => {
    if (!oAuthsEnabledByFlowConfig[OAuthProviders.Apple]) {
      oAuthsEnabledByFlowConfig[OAuthProviders.Apple] = isAppleUngated;
    }
  }, [isAppleUngated, oAuthsEnabledByFlowConfig]);
  return {
    oAuthsEnabledByFlowConfig,
    atLeastOneOAuthEnabled
  };
};